module.exports = __webpack_public_path__ + "img/gys_4@2x.404e8c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_4@2x.png
// module id = eKVb
// module chunks = 0